import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Radio from 'components/button/button';

export default class RadioOption extends React.Component {
  constructor(props) {
    super();

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * Handles click event that will change the active option
   *
   * @method  handleClick
   */
  handleClick() {
    this.props.changeActiveOption(this.props.index)
  }

  render() {
    const { isActive, buttonTxt, id, index } = this.props;
    const radioOptionClasses = classNames(
      'radioOption',
      {
        'radioOption_active': isActive
      }
    );

    return (
      <label
        className={radioOptionClasses}
        htmlFor={id}
      >
        <input
          checked={isActive}
          onChange={this.handleClick}
          className="radio isVisuallyHidden"
          id={id}
          type="radio"
        />
        <span>{buttonTxt}</span>
      </label>
    );
  }
}

RadioOption.propTypes = {
  'buttonTxt': PropTypes.string,
  'changeActiveOption': PropTypes.func.isRequired,
  'id': PropTypes.string,
  'index': PropTypes.number.isRequired,
  'isActive': PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/client/components/fields/radios/radio-option.jsx